import lightGallery from 'lightgallery';
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgZoom from 'lightgallery/plugins/zoom';

const GalleryWall = () => {
    const galleries = document.querySelectorAll('.gallery-wall__images-wrapper');
    
    if (!galleries.length) return;

    galleries.forEach(gallery => {
        lightGallery(gallery, {
            speed: 300,
            plugins: [lgThumbnail, lgZoom],
            thumbnail: true,
            animateThumb: true,
            zoomFromOrigin: false,
            allowMediaOverlap: true,
            toggleThumb: true,
            download: false,
            getCaptionFromTitleOrAlt: true,
            addClass: 'lg-custom-theme',
            mode: 'lg-fade',
            licenseKey: '1234588F095A1-52DC-45C5-A818-1481488E713267890',
        });
    });
};

export default GalleryWall; 